export default class BasePage {
  constructor(id, meta) {
    this.id = id;
    this.meta = meta || {};
  }

  async mount(context) {
    await this.render(context);
    await this.onEnter(context);
  }

  async unmount(context) {
    await this.onLeave(context);
  }

  async render(context) {
    if (this.meta.title) {
      document.title = this.meta.title;
    }
    if (context && context.layout) {
      context.layout.setHeaderTitle(this.meta.headerTitle || '');
    }
  }

  async onEnter() {}

  async onLeave() {}
}
